export const environment = {
  env: 'prod',
  API_URL: 'https://api.mandantenportal.eu',
  joditKey: '690BE-3BH83-AEMM5-SHNQX',
  WEBSOCKET_URL: 'wss://api.mandantenportal.eu/ws',
  KEYCLOAK_URL: 'https://mandantenportal.eu/auth/',
  MAX_UPLOAD_SIZE_MB: 500,
  ALLOWED_FILE_FORMATS: 'application/pdf, image/png, image/jpeg',
};
